/** Light haptic feedback on supported devices — no-op elsewhere. */
const vibrate = (pattern) => {
  try {
    if (typeof navigator !== 'undefined' && navigator.vibrate) {
      navigator.vibrate(pattern);
    }
  } catch {
    /* unsupported */
  }
};

export const hapticSelection = () => vibrate(10);
export const hapticSuccess = () => vibrate([12, 40, 12]);
export const hapticSos = () => vibrate([80, 60, 80, 60, 80]);
